export default __webpack_public_path__ + "static/media/logoM.a5eeca61.png";